/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 查询我的礼品卡
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class SelMyselfGiftCardInfoParams {
  constructor(public pageNum: number, public pageSize: number) {}
}

export default async function (
  params: SelMyselfGiftCardInfoParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: member.Page<member.GiftCardRes>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/member/user`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
